<template>
	<div id="subjectlist">
		<div class="examinfo">
		    <div class="left">
			正确：<div class="right">{{subjectlog.right_count}}</div>  错误：<div class="wrong">{{subjectlog.wrong_count}}</div>   正确率：<div class="accuracy">{{subjectlog.right_proportion}}</div>
		      </div>
		  </div>
		  <div class='timu-status'>
		    <div class='tm-order'>
		      <div v-on:click="event_setsubject(item)" v-bind:class="{nostarted:item.status === false,right:item.status == 1,wrong:item.status !== false && item.status != 1}" v-for="(item,index) in subjectlog.subject_list">
			<span>{{item.subject_number}}</span>
		      </div>
		    </div>
		  </div>
	</div>
</template>

<script>
import { Toast , Dialog} from 'we-vue'
export default {
	name: 'Subjectlist',
	data () {
		return {
			subjectlog:{}
		}
	},
	created (){
		var that = this;
		var options = this.$route.query
	    this.$app.r('/api/subject/subjectdetail',{
			id:options.id
	    },function(response){
			that.setData({
				subjectlog:response.data
			});
	    });
	},


	methods:{
		setData(params){
			for(var n in params){
				this[n] = params[n]
			}
		},
		event_setsubject: function(item){
			this.$store.state.fee_subject_id = this.subjectlog.id+':'+item.subject_id;
			this.$router.back(-1)
		}
	}
}
</script>
<style scoped>
	#subjectlist{
		background-color:#EFEFEF;
		min-height:100vh;
	}
.examinfo{
  background: #fff;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.examinfo .left{
  display: flex;
  font-size: 14px;
}
.examinfo .right{
  color: #32b16c;
  margin-right: 10px;
}
.examinfo .wrong{
  color: #32b16c;
  margin-right: 10px;
}
.examinfo .accuracy{
  color: #eb6100;
}
.examinfo .right-arrow{
  width: 25px;
  height: 25px;
  background:url(http://jk.ioccn.com/jiakao/arrowdown.png) no-repeat;
}
.timu-status{
  margin-top: 15px;
}
.timu-status .tm-style{
  font-size: 14px;
  padding-left: 10px;
}
.timu-status .tm-order{
  display: flex;
  flex-flow: row wrap;
  padding-right: 2vw;
  padding-left:2vw;
}
.timu-status .tm-order div{
  margin-top: 10px;
  margin-left: 2vw;
  margin-right:2vw;
  width: 11vw;
  display: inline-block;
  border-radius: 100%;
  background: #fff;
  border: 1px solid #dedede;
  height: 11vw;
  text-align: center;
  line-height: 11vw;
}
.timu-status .tm-order div.right{
  background: #edfef5;
}
.timu-status .tm-order div.wrong{
  background: #ffe8ea;
}
.timu-status .tm-order div.cur{
  background: #2cd5ff;
}
</style>



// WEBPACK FOOTER //
// src/components/Subjectlist.vue